<template>
    <div class="container">
        <Nav></Nav>
        <div style="width:100%; height:80px;"></div>
        <Row height="720" bg="assets/pc/service/innovation/p1_bg.jpg"> </Row>
        <Row height="1050" bgColor="#fff">
            <div class="pos2">
                <img src="@/assets/pc/service/innovation/pos2_banner.png" />
                <h1>数字营销与文化产业融合共促 创新引领行业发展</h1>
                <p>延伸布局元宇宙虚拟资产、影视IP运营、电竞娱乐等领域，打破营销次元，推进数字化赋能<br />文创业态发展，构建数字资产实现由实体到虚拟的价值与新营销生态体系。</p>
            </div>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from "@/components/pc/nav.vue";
import Footer from "@/components/pc/footer.vue";
import Row from "@/components/pc/Row.vue";
export default {
    name: "pc-service-innovation",
    components: { Nav, Footer, Row },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
};
</script>
<style scoped>
.pos2 {
    width: 100%;
    height: 100%;
    text-align: center;
}
.pos2 p {
    font-size: 1.8rem;
    line-height: 4.5rem;
}

@media only screen and (max-width: 2048px) {
    .pos2 img {
        margin-top: 100px;
        width: calc(1300px * var(--scale));
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 140px 0 80px 0;
    }
}

@media only screen and (min-width: 2049px) {
    .pos2 img {
        margin-top: 120px;
        width: 1300px;
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 200px 0 80px 0;
    }
}

</style>
